import CoreCredentials from './CoreCredentials';

export { type CoreCredentialsProps } from './CoreCredentials';
export default CoreCredentials;
